import PlurallClient from '@plurall/client'
import { getToken } from './token'

const graphqlClient = () => {
  const authToken = getToken()

  const client = new PlurallClient({
    apiURL: process.env.REACT_APP_PLURALL_API_URL,
    graphqlURL: process.env.REACT_APP_SOMOS_GRAPHQL_URL,
    applicationId: process.env.REACT_APP_ID_APPLICATION,
    accessToken: authToken,
  })

  return client.graphqlClient
}

const handleGraphQLErrors = graphQLErrors => graphQLErrors.map(error => error.message)

const handleGraphQLErrorsWithMessage = (errors, defaultError) => {
  if (errors?.graphQLErrors) {
    return errors?.graphQLErrors.map(error => error.message)
  }

  return [defaultError]
}

const handleGraphQLErrorsWithToast = (errors, defaultError) => {
  if (errors?.graphQLErrors) {
    return errors?.graphQLErrors?.map(({ message }) =>
      window.PLURALL_ELO_TOAST_CONTAINER.addToast({
        variant: 'negative',
        text: message,
      }),
    )
  }
  return window.PLURALL_ELO_TOAST_CONTAINER.addToast({
    variant: 'negative',
    text: defaultError,
  })
}

export {
  graphqlClient,
  handleGraphQLErrors,
  handleGraphQLErrorsWithToast,
  handleGraphQLErrorsWithMessage,
}
